import { API, API_GET } from "../../../Config"


export const GetDietPlans = () => {
  return (
    API_GET(API.GetDiet)
  )
}

